import { DatePicker } from "@mui/x-date-pickers";
import dayjs, { Dayjs } from "dayjs";

interface DatePickerFilterProps {
  filterValue: string | undefined
  column: any
}

export default function DatePickerFilter({
  filterValue,
  column
}: DatePickerFilterProps) {

  return (
    <DatePicker
      format="YYYY-MM-DD"
      value={filterValue ? dayjs(filterValue) : null}
      onChange={(d: Dayjs | null) => {
        column.setFilterValue(d ? d.format("YYYY-MM-DD") : undefined);
      }}
      slotProps={{
        textField: {
          variant: "standard",
          label: undefined,
          placeholder: "Selecciona fecha",
          InputLabelProps: { shrink: false },
          InputProps: { disableUnderline: true },
          sx: {
            "& .MuiInputBase-root": {
              border: "none",
              background: "transparent",
            },
            "& fieldset": { border: "none" },
          },
        },
      }}
    />

  )

}